import React from 'react'

import { Body1, Caption1 } from '@ui/Typography/Typography'

import { Box } from '@shared/components/Box'

interface Props {
  label: string
  value: string
}

export const ModalBodyLabeledInfo: React.FC<Props> = ({ label, value }) => (
  <Box flex direction='column' gap='x4'>
    <Caption1 color='text-med-em'>{label}</Caption1>
    <Body1 medium color='text-high-em'>
      {value}
    </Body1>
  </Box>
)
